import {
    Client,
    Configuration,
    type SearchShowsByFiltersRequest,
} from 'streaming-availability'
import { unref } from 'vue'

const useStreamingSDK = () => {
    const config = useRuntimeConfig()

    const baseUrl = import.meta.server
        ? config.public.baseUrl
        : window.location.origin

    const sdk = new Client(
        new Configuration({
            basePath: `${baseUrl}/api/streaming-api`,
        })
    )

    return sdk
}

export const useStreamingAvailability = () => {
    const sdk = useStreamingSDK()

    const useAsyncGetShow = (id: string | undefined) => {
        if (!id) {
            throw createError({
                statusCode: 404,
                statusMessage: 'Show not found',
            })
        }
        return useAsyncData(() => sdk.showsApi.getShow({ id }))
    }

    const useAsyncSearchShows = (
        params: MaybeRef<Omit<SearchShowsByFiltersRequest, 'country'>>
    ) => {
        const data = unref(params)
        return useAsyncData(
            `search-shows-${data.showType}-${data.orderBy}-${data.cursor ?? 'none'}-${data.keyword ?? 'none'}`,
            () => {
                const data = unref(params)
                return sdk.showsApi.searchShowsByFilters({
                    country: DEFAULT_COUNTRY_CODE,
                    ...data,
                })
            },
            {
                watch: [params],
            }
        )
    }

    return {
        sdk,
        useAsyncGetShow,
        useAsyncSearchShows,
    }
}
